import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noHtmlTags',
})
export class StripTagsPipe implements PipeTransform {
  public transform(value: string, args?: any): string {
    let resultText: string = undefined;
    if(value) {
      // remove html tags
      resultText = value.replace(/<[^>]+>/gm, '');
      // remove html entities
      resultText = resultText.replace(/(&.[^&;]+;)/ig, ' ');
    }
    return resultText;
  }
}
